export default __webpack_public_path__ + "static/media/A527.5e335641.webp";